import { render, staticRenderFns } from "./WarningMessage.vue?vue&type=template&id=573af69d&scoped=true"
import script from "./WarningMessage.vue?vue&type=script&lang=js"
export * from "./WarningMessage.vue?vue&type=script&lang=js"
import style0 from "./WarningMessage.vue?vue&type=style&index=0&id=573af69d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573af69d",
  null
  
)

export default component.exports